import React, { createContext, useReducer, Dispatch, ReactNode } from 'react';
import { datepickerReducer, DatepickerAction } from './reducer';

export interface DatepickerState {
  startDate: Date | null;
  endDate: Date | null;
  rangeError: string | null;
  startDateError: string | null;
  endDateError: string | null;
  isRange: boolean;
}

const initialState: DatepickerState = {
  startDate: null,
  endDate: null,
  rangeError: null,
  startDateError: null,
  endDateError: null,
  isRange: true,
};

export const DatepickerContext = createContext<{
  state: DatepickerState;
  dispatch: Dispatch<DatepickerAction>;
}>({
  state: initialState,
  dispatch: () => undefined,
});

export const DatepickerProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(datepickerReducer, initialState);
  return (
    <DatepickerContext.Provider value={{ state, dispatch }}>
      {children}
    </DatepickerContext.Provider>
  );
};
